/** */
const { REACT_APP_ENV } = process.env;

const app_config = {
  development: {
    landing: 'http://localhost:3001',
    editor: 'http://localhost:3003',
    files: 'http://localhost:4010',
    agents: 'http://localhost:4026',
    iam: 'http://localhost:4011',
    mailing: 'http://localhost:4017',
    mailometric: 'http://localhost:4017',
    messaging: 'http://localhost:4014',
    mobi_push: 'http://localhost:4020',
    postal: 'http://localhost:4008',
    sales: 'http://localhost:4003',
    users: 'http://localhost:4001',
    notification: 'http://localhost:4007',
    automata: 'http://localhost:4016',
    terms: 'http://localhost:3001/terms',
    policy: 'http://localhost:3001/privacy'
  },
  testing: {
    landing: 'https://gm-g6.xyz',
    editor: 'https://editor.gm-g6.xyz',
    files: 'https://files.gm-g6.xyz',
    iam: 'https://iam.gm-g6.xyz',
    agents: 'https://agents.gm-g6.xyz',
    mailing: 'https://mails.gm-g6.xyz',
    mailometric: 'https://mailometric.gm-g6.xyz',
    messaging: 'https://messaging.gm-g6.xyz',
    mobi_push: 'https://mobi-push.gm-g6.xyz',
    postal: 'https://postal.gm-g6.xyz',
    sales: 'https://sales.gm-g6.xyz',
    users: 'https://users.gm-g6.xyz',
    notification: 'https://notification.gm-g6.xyz',
    automata: 'https://automation.gm-g6.xyz',
    terms: 'https://gm-g6.xyz/terms',
    policy: 'https://gm-g6.xyz/privacy'
  },
  staging: {
    landing: 'https://gm-g7.xyz',
    editor: 'https://editor.gm-g7.xyz',
    files: 'https://files.gm-g7.xyz',
    iam: 'https://iam.gm-g7.xyz',
    agents: 'https://agents.gm-g7.xyz',
    mailing: 'https://mails.gm-g7.xyz',
    mailometric: 'https://mailometric.gm-g7.xyz',
    messaging: 'https://messaging.gm-g7.xyz',
    mobi_push: 'https://mobi-push.gm-g7.xyz',
    postal: 'https://postal.gm-g7.xyz',
    sales: 'https://sales.gm-g7.xyz',
    users: 'https://users.gm-g7.xyz',
    notification: 'https://notification.gm-g7.xyz',
    automata: 'https://automation.gm-g7.xyz',
    terms: 'https://gm-g7.xyz/terms',
    policy: 'https://gm-g7.xyz/privacy'
  },
  production: {
    landing: 'https://go-mailer.com',
    editor: 'https://editor.go-mailer.com',
    files: 'https://files.go-mailer.com',
    iam: 'https://iam.go-mailer.com',
    agents: 'https://agents.go-mailer.com',
    mailing: 'https://mails.go-mailer.com',
    mailometric: 'https://mailometric.go-mailer.com',
    messaging: 'https://messaging.go-mailer.com',
    mobi_push: 'https://mobi-push.go-mailer.com',
    postal: 'https://postal.go-mailer.com',
    sales: 'https://sales.go-mailer.com',
    users: 'https://users.go-mailer.com',
    notification: 'https://notification.go-mailer.com',
    automata: 'https://automation.go-mailer.com',
    terms: 'https://go-mailer.com/terms',
    policy: 'https://go-mailer.com/privacy'
  }
};

export const urls = { ...app_config[REACT_APP_ENV || 'development'] };
